import _taggedTemplateLiteral from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["<dom-module id=\"lumo-form-item\" theme-for=\"vaadin-form-item\">\n  <template>\n    <style>\n      :host {\n        --vaadin-form-item-row-spacing: 0;\n      }\n\n      /* font-weight, margin-bottom, transition and line-height same values as for part label in text-field */\n      [part=\"label\"] {\n        color: var(--lumo-secondary-text-color);\n        font-family: var(--lumo-font-family);\n        font-size: var(--lumo-font-size-s);\n        font-weight: 500;\n        margin-top: var(--lumo-space-m);\n        margin-left: calc(var(--lumo-border-radius) / 4);\n        margin-bottom: var(--lumo-space-xs);\n        transition: color 0.4s;\n        line-height: 1.333;\n      }\n    </style>\n  </template>\n</dom-module>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import '@vaadin/vaadin-lumo-styles/color.js';
import '@vaadin/vaadin-lumo-styles/spacing.js';
import '@vaadin/vaadin-lumo-styles/style.js';
import '@vaadin/vaadin-lumo-styles/typography.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
var $_documentContainer = html(_templateObject());
document.head.appendChild($_documentContainer.content);